import * as React from 'react'

const SvgLazada = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    viewBox='0 0 150 150'
    {...props}
  >
    <defs>
      <linearGradient id='Lazada_svg__d'>
        <stop
          style={{
            stopColor: '#6fc4ea',
            stopOpacity: 1
          }}
          offset={0}
        />
        <stop
          style={{
            stopColor: '#bce4f5',
            stopOpacity: 1
          }}
          offset={1}
        />
      </linearGradient>
      <linearGradient id='Lazada_svg__c'>
        <stop
          offset={0}
          style={{
            stopColor: '#f8ad1b',
            stopOpacity: 1
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: '#fec80d',
            stopOpacity: 1
          }}
        />
      </linearGradient>
      <linearGradient id='Lazada_svg__b'>
        <stop
          style={{
            stopColor: '#4eb745',
            stopOpacity: 1
          }}
          offset={0}
        />
        <stop
          style={{
            stopColor: '#c8db30',
            stopOpacity: 1
          }}
          offset={1}
        />
      </linearGradient>
      <linearGradient id='Lazada_svg__a'>
        <stop
          style={{
            stopColor: '#f6a51f',
            stopOpacity: 1
          }}
          offset={0}
        />
        <stop
          style={{
            stopColor: '#ffd42a',
            stopOpacity: 1
          }}
          offset={1}
        />
      </linearGradient>
      <linearGradient
        id='Lazada_svg__e'
        y2={0.5}
        x2={1.001}
        y1={0.5}
        x1={-0.001}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#ff9200' offset={0} />
        <stop stopColor='#f36d00' offset={0.29} />
        <stop stopColor='#f4680b' offset={0.32} />
        <stop stopColor='#f83c72' offset={0.57} />
        <stop stopColor='#fc1cbe' offset={0.78} />
        <stop stopColor='#fe08ed' offset={0.93} />
        <stop stopColor='#f0f' offset={1} />
      </linearGradient>
      <linearGradient
        gradientUnits='userSpaceOnUse'
        x1={-0.001}
        y1={0.5}
        x2={1.001}
        y2={0.5}
        id='Lazada_svg__f'
      >
        <stop
          style={{
            stopColor: '#ffb900',
            stopOpacity: 1
          }}
          offset={0}
          stopColor='#ff9200'
        />
        <stop
          style={{
            stopColor: '#f38000',
            stopOpacity: 1
          }}
          offset={0.338}
          stopColor='#f36d00'
        />
        <stop offset={0.567} stopColor='#f83c72' />
        <stop offset={0.78} stopColor='#fc1cbe' />
        <stop offset={0.93} stopColor='#fe08ed' />
        <stop offset={1} stopColor='#f0f' />
      </linearGradient>
      <linearGradient id='Lazada_svg__h'>
        <stop
          style={{
            stopColor: '#ed6600',
            stopOpacity: 1
          }}
          offset={0}
        />
        <stop
          style={{
            stopColor: '#f98200',
            stopOpacity: 1
          }}
          offset={1}
        />
      </linearGradient>
      <linearGradient id='Lazada_svg__g'>
        <stop
          style={{
            stopColor: '#ee0a3f',
            stopOpacity: 1
          }}
          offset={0}
        />
        <stop
          style={{
            stopColor: '#ee0a3f',
            stopOpacity: 0
          }}
          offset={1}
        />
      </linearGradient>
      <linearGradient
        xlinkHref='#Lazada_svg__e'
        id='Lazada_svg__i'
        gradientUnits='userSpaceOnUse'
        x1={-0.001}
        y1={0.5}
        x2={1.001}
        y2={0.5}
      />
      <linearGradient
        xlinkHref='#Lazada_svg__f'
        id='Lazada_svg__j'
        gradientUnits='userSpaceOnUse'
        x1={-0.001}
        y1={0.5}
        x2={66.758}
        y2={-0.017}
      />
      <linearGradient
        xlinkHref='#Lazada_svg__g'
        id='Lazada_svg__k'
        x1={18.754}
        y1={49.006}
        x2={86.818}
        y2={11.32}
        gradientUnits='userSpaceOnUse'
      />
      <linearGradient
        xlinkHref='#Lazada_svg__h'
        id='Lazada_svg__m'
        x1={41.793}
        y1={39.349}
        x2={75.037}
        y2={12.569}
        gradientUnits='userSpaceOnUse'
      />
      <linearGradient
        xlinkHref='#Lazada_svg__g'
        id='Lazada_svg__l'
        gradientUnits='userSpaceOnUse'
        x1={18.754}
        y1={49.006}
        x2={86.818}
        y2={11.32}
      />
      <linearGradient
        xlinkHref='#Lazada_svg__h'
        id='Lazada_svg__n'
        gradientUnits='userSpaceOnUse'
        x1={41.793}
        y1={39.349}
        x2={75.037}
        y2={12.569}
      />
    </defs>
    <g
      style={{
        fill: 'url(#Lazada_svg__i)',
        fillRule: 'evenodd',
        stroke: 'none',
        strokeWidth: 1,
        strokeLinecap: 'square',
        strokeLinejoin: 'bevel'
      }}
      transform='translate(-.049) scale(1.96487)'
    >
      <path
        style={{
          vectorEffect: 'none',
          fill: 'url(#Lazada_svg__j)',
          fillRule: 'nonzero'
        }}
        d='M33.737 54.716c-.479.003-.95-.12-1.366-.355-3.565-2.063-29.967-18.617-30.964-19.122A2.39 2.39 0 0 1 .04 33.327v-23.22A2.513 2.513 0 0 1 1.175 7.95l.19-.109C3.92 6.256 12.47 1.038 13.823.287A2.05 2.05 0 0 1 14.847 0c.338.004.67.088.97.246 0 0 11.964 7.799 13.795 8.495a9.438 9.438 0 0 0 4.097.861 9.178 9.178 0 0 0 4.59-1.12C40.087 7.54 51.52.287 51.642.287c.288-.174.62-.264.956-.26.361.002.715.101 1.024.287 1.558.86 12.157 7.348 12.607 7.635a2.458 2.458 0 0 1 1.188 2.131V33.3a2.363 2.363 0 0 1-1.365 1.912c-.997.546-27.317 17.1-30.95 19.122a2.732 2.732 0 0 1-1.366.382'
      />
    </g>
    <g
      style={{
        fill: 'url(#Lazada_svg__k)',
        fillOpacity: 1,
        fillRule: 'evenodd',
        stroke: 'none',
        strokeWidth: 1,
        strokeLinecap: 'square',
        strokeLinejoin: 'bevel'
      }}
      transform='translate(-.049) scale(1.96487)'
    >
      <path
        style={{
          vectorEffect: 'none',
          fill: 'url(#Lazada_svg__l)',
          fillOpacity: 1,
          fillRule: 'nonzero'
        }}
        d='M33.6 54.716h.137c.478.003.95-.12 1.365-.355 3.565-2.063 29.954-18.617 30.95-19.122a2.363 2.363 0 0 0 1.366-1.912v-23.22a2.484 2.484 0 0 0-.259-1.133L33.6 27.399v27.317'
      />
    </g>
    <g
      style={{
        fill: 'url(#Lazada_svg__m)',
        fillOpacity: 1,
        fillRule: 'evenodd',
        stroke: 'none',
        strokeWidth: 1,
        strokeLinecap: 'square',
        strokeLinejoin: 'bevel'
      }}
    >
      <path
        d='M33.6 54.716h.137c.478.003.95-.12 1.365-.355 3.565-2.063 29.954-18.617 30.95-19.122a2.363 2.363 0 0 0 1.366-1.912v-23.22a2.484 2.484 0 0 0-.259-1.133L33.6 27.399v27.317'
        style={{
          vectorEffect: 'none',
          fill: 'url(#Lazada_svg__n)',
          fillOpacity: 1,
          fillRule: 'nonzero'
        }}
        transform='matrix(-1.94394 0 0 1.94394 131.058 .502)'
      />
    </g>
  </svg>
)

export default SvgLazada
